import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmployeeSnackbars } from '../types/employee-snackbars.config';

@Injectable({
  providedIn: 'root',
})
export class EmployeeSnackbarsService {
  private snackbar = inject(MatSnackBar);

  public successRegister(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRegister.message,
      EmployeeSnackbars.successRegister.closeBtn,
      EmployeeSnackbars.successRegister.config
    );
  }

  public successUpdated(): void {
    this.snackbar.open(
      EmployeeSnackbars.successUpdated.message,
      EmployeeSnackbars.successUpdated.closeBtn,
      EmployeeSnackbars.successUpdated.config
    );
  }

  public successAddressUpdated(): void {
    this.snackbar.open(
      EmployeeSnackbars.successAddressUpdated.message,
      EmployeeSnackbars.successAddressUpdated.closeBtn,
      EmployeeSnackbars.successAddressUpdated.config
    );
  }

  public successDisabilityRegistered(): void {
    this.snackbar.open(
      EmployeeSnackbars.successDisabilityRegistered.message,
      EmployeeSnackbars.successDisabilityRegistered.closeBtn,
      EmployeeSnackbars.successDisabilityRegistered.config
    );
  }

  public successDisabilityUpdated(): void {
    this.snackbar.open(
      EmployeeSnackbars.successDisabilityUpdated.message,
      EmployeeSnackbars.successDisabilityUpdated.closeBtn,
      EmployeeSnackbars.successDisabilityUpdated.config
    );
  }

  public successSendInvitation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successSendInvitation.message,
      EmployeeSnackbars.successSendInvitation.closeBtn,
      EmployeeSnackbars.successSendInvitation.config
    );
  }

  public successResendInvitation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successResendInvitation.message,
      EmployeeSnackbars.successResendInvitation.closeBtn,
      EmployeeSnackbars.successResendInvitation.config
    );
  }

  public successCopiedPin(): void {
    this.snackbar.open(
      EmployeeSnackbars.successCopiedPin.message,
      EmployeeSnackbars.successCopiedPin.closeBtn,
      EmployeeSnackbars.successCopiedPin.config
    );
  }

  public successCopiedNfc(): void {
    this.snackbar.open(
      EmployeeSnackbars.successCopiedNfc.message,
      EmployeeSnackbars.successCopiedNfc.closeBtn,
      EmployeeSnackbars.successCopiedNfc.config
    );
  }

  public failureSendInvitation(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureSendInvitation.message,
      EmployeeSnackbars.failureSendInvitation.closeBtn,
      EmployeeSnackbars.failureSendInvitation.config
    );
  }

  public failureQuotaOfUsersIsExhausted(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQuotaOfUsersIsExhausted.message,
      EmployeeSnackbars.failureQuotaOfUsersIsExhausted.closeBtn,
      EmployeeSnackbars.failureQuotaOfUsersIsExhausted.config
    );
  }

  public successCancelInvitation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successCancelInvitation.message,
      EmployeeSnackbars.successCancelInvitation.closeBtn,
      EmployeeSnackbars.successCancelInvitation.config
    );
  }

  public failureCancelInvitation(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureCancelInvitation.message,
      EmployeeSnackbars.failureCancelInvitation.closeBtn,
      EmployeeSnackbars.failureCancelInvitation.config
    );
  }

  public successEmployeeUserDelete(): void {
    this.snackbar.open(
      EmployeeSnackbars.successEmployeeUserDelete.message,
      EmployeeSnackbars.successEmployeeUserDelete.closeBtn,
      EmployeeSnackbars.successEmployeeUserDelete.config
    );
  }

  public failureEmployeeUserDelete(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureEmployeeUserDelete.message,
      EmployeeSnackbars.failureEmployeeUserDelete.closeBtn,
      EmployeeSnackbars.failureEmployeeUserDelete.config
    );
  }

  public successChannelUpdate(): void {
    this.snackbar.open(
      EmployeeSnackbars.successChannelUpdate.message,
      EmployeeSnackbars.successChannelUpdate.closeBtn,
      EmployeeSnackbars.successChannelUpdate.config
    );
  }

  public failureChannelUpdate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureChannelUpdate.message,
      EmployeeSnackbars.failureChannelUpdate.closeBtn,
      EmployeeSnackbars.failureChannelUpdate.config
    );
  }

  public successRegisterLocation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRegisterLocation.message,
      EmployeeSnackbars.successRegisterLocation.closeBtn,
      EmployeeSnackbars.successRegisterLocation.config
    );
  }

  public successUpdateLocation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successUpdateLocation.message,
      EmployeeSnackbars.successUpdateLocation.closeBtn,
      EmployeeSnackbars.successUpdateLocation.config
    );
  }

  public successRemoveLocation(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRemoveLocation.message,
      EmployeeSnackbars.successRemoveLocation.closeBtn,
      EmployeeSnackbars.successRemoveLocation.config
    );
  }

  public failureRegisterLocation(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureRegisterLocation.message,
      EmployeeSnackbars.failureRegisterLocation.closeBtn,
      EmployeeSnackbars.failureRegisterLocation.config
    );
  }

  public successRegisterIP(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRegisterIP.message,
      EmployeeSnackbars.successRegisterIP.closeBtn,
      EmployeeSnackbars.successRegisterIP.config
    );
  }

  public successUpdateIP(): void {
    this.snackbar.open(
      EmployeeSnackbars.successUpdateIP.message,
      EmployeeSnackbars.successUpdateIP.closeBtn,
      EmployeeSnackbars.successUpdateIP.config
    );
  }

  public successRemoveIp(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRemoveIp.message,
      EmployeeSnackbars.successRemoveIp.closeBtn,
      EmployeeSnackbars.successRemoveIp.config
    );
  }

  public failureRegisterIP(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureRegisterIP.message,
      EmployeeSnackbars.failureRegisterIP.closeBtn,
      EmployeeSnackbars.failureRegisterIP.config
    );
  }

  public createBagHoursSuccess(): void {
    this.snackbar.open(
      EmployeeSnackbars.createBagHoursSuccess.message,
      EmployeeSnackbars.createBagHoursSuccess.closeBtn,
      EmployeeSnackbars.createBagHoursSuccess.config
    );
  }

  public updateBagHoursSuccess(): void {
    this.snackbar.open(
      EmployeeSnackbars.updateBagHoursSuccess.message,
      EmployeeSnackbars.updateBagHoursSuccess.closeBtn,
      EmployeeSnackbars.updateBagHoursSuccess.config
    );
  }

  public deleteBagHoursSuccess(): void {
    this.snackbar.open(
      EmployeeSnackbars.deleteBagHoursSuccess.message,
      EmployeeSnackbars.deleteBagHoursSuccess.closeBtn,
      EmployeeSnackbars.deleteBagHoursSuccess.config
    );
  }

  public failureBagHours(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureBagHours.message,
      EmployeeSnackbars.failureBagHours.closeBtn,
      EmployeeSnackbars.failureBagHours.config
    );
  }

  public failExport(): void {
    this.snackbar.open(
      EmployeeSnackbars.failExport.message,
      EmployeeSnackbars.failExport.closeBtn,
      EmployeeSnackbars.failExport.config
    );
  }

  public successRegisterContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.successRegisterContract.message,
      EmployeeSnackbars.successRegisterContract.closeBtn,
      EmployeeSnackbars.successRegisterContract.config
    );
  }

  public failureRegisterContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureRegisterContract.message,
      EmployeeSnackbars.failureRegisterContract.closeBtn,
      EmployeeSnackbars.failureRegisterContract.config
    );
  }

  public EmployeeContractExists(): void {
    this.snackbar.open(
      EmployeeSnackbars.EmployeeContractExists.message,
      EmployeeSnackbars.EmployeeContractExists.closeBtn,
      EmployeeSnackbars.EmployeeContractExists.config
    );
  }

  public successUpdateContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.successUpdateContract.message,
      EmployeeSnackbars.successUpdateContract.closeBtn,
      EmployeeSnackbars.successUpdateContract.config
    );
  }

  public failureUpdateEffectiveDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureUpdateEffectiveDate.message,
      EmployeeSnackbars.failureUpdateEffectiveDate.closeBtn,
      EmployeeSnackbars.failureUpdateEffectiveDate.config
    );
  }

  public failureColitionDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureColitionDate.message,
      EmployeeSnackbars.failureColitionDate.closeBtn,
      EmployeeSnackbars.failureColitionDate.config
    );
  }

  public failureUpdateDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureUpdateDate.message,
      EmployeeSnackbars.failureUpdateDate.closeBtn,
      EmployeeSnackbars.failureUpdateDate.config
    );
  }

  public errorContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.errorContract.message,
      EmployeeSnackbars.errorContract.closeBtn,
      EmployeeSnackbars.errorContract.config
    );
  }

  public successDeleteContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.successDeleteContract.message,
      EmployeeSnackbars.successDeleteContract.closeBtn,
      EmployeeSnackbars.successDeleteContract.config
    );
  }

  public failureDeleteContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureDeleteContract.message,
      EmployeeSnackbars.failureDeleteContract.closeBtn,
      EmployeeSnackbars.failureDeleteContract.config
    );
  }

  public successPromoteContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.successPromoteContract.message,
      EmployeeSnackbars.successPromoteContract.closeBtn,
      EmployeeSnackbars.successPromoteContract.config
    );
  }

  public failurePromoteContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.failurePromoteContract.message,
      EmployeeSnackbars.failurePromoteContract.closeBtn,
      EmployeeSnackbars.failurePromoteContract.config
    );
  }

  public ErrorContractOngoing(): void {
    this.snackbar.open(
      EmployeeSnackbars.ErrorContractOngoing.message,
      EmployeeSnackbars.ErrorContractOngoing.closeBtn,
      EmployeeSnackbars.ErrorContractOngoing.config
    );
  }

  public failureEffectDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureEffectDate.message,
      EmployeeSnackbars.failureEffectDate.closeBtn,
      EmployeeSnackbars.failureEffectDate.config
    );
  }

  public ErrorContractEffectDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.ErrorContractEffectDate.message,
      EmployeeSnackbars.ErrorContractEffectDate.closeBtn,
      EmployeeSnackbars.ErrorContractEffectDate.config
    );
  }

  public successConditionContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.successConditionContract.message,
      EmployeeSnackbars.successConditionContract.closeBtn,
      EmployeeSnackbars.successConditionContract.config
    );
  }

  public failureConditionContract(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureConditionContract.message,
      EmployeeSnackbars.failureConditionContract.closeBtn,
      EmployeeSnackbars.failureConditionContract.config
    );
  }

  public lastContractRequired(): void {
    this.snackbar.open(
      EmployeeSnackbars.lastContractRequired.message,
      EmployeeSnackbars.lastContractRequired.closeBtn,
      EmployeeSnackbars.lastContractRequired.config
    );
  }

  public invalidTerminationDate(): void {
    this.snackbar.open(
      EmployeeSnackbars.invalidTerminationDate.message,
      EmployeeSnackbars.invalidTerminationDate.closeBtn,
      EmployeeSnackbars.invalidTerminationDate.config
    );
  }

  public alreadyTerminated(): void {
    this.snackbar.open(
      EmployeeSnackbars.alreadyTerminated.message,
      EmployeeSnackbars.alreadyTerminated.closeBtn,
      EmployeeSnackbars.alreadyTerminated.config
    );
  }

  public invalidContractSequence(): void {
    this.snackbar.open(
      EmployeeSnackbars.invalidContractSequence.message,
      EmployeeSnackbars.invalidContractSequence.closeBtn,
      EmployeeSnackbars.invalidContractSequence.config
    );
  }

  public failureUpdateNfc(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureUpdateNfc.message,
      EmployeeSnackbars.failureUpdateNfc.closeBtn,
      EmployeeSnackbars.failureUpdateNfc.config
    );
  }

  public successNfcRegistrationEnabled(): void {
    this.snackbar.open(
      EmployeeSnackbars.successNfcRegistrationEnabled.message,
      EmployeeSnackbars.successNfcRegistrationEnabled.closeBtn,
      EmployeeSnackbars.successNfcRegistrationEnabled.config
    );
  }

  public successNfcRegistrationDisabled(): void {
    this.snackbar.open(
      EmployeeSnackbars.successNfcRegistrationDisabled.message,
      EmployeeSnackbars.successNfcRegistrationDisabled.closeBtn,
      EmployeeSnackbars.successNfcRegistrationDisabled.config
    );
  }

  public failureNfcRegistrationUpdate(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureNfcRegistrationUpdate.message,
      EmployeeSnackbars.failureNfcRegistrationUpdate.closeBtn,
      EmployeeSnackbars.failureNfcRegistrationUpdate.config
    );
  }

  public successQrDownload(): void {
    this.snackbar.open(
      EmployeeSnackbars.successQrDownload.message,
      EmployeeSnackbars.successQrDownload.closeBtn,
      EmployeeSnackbars.successQrDownload.config
    );
  }

  public failureQrDownload(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrDownload.message,
      EmployeeSnackbars.failureQrDownload.closeBtn,
      EmployeeSnackbars.failureQrDownload.config
    );
  }

  public failureQrDownloadEmployee(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrDownloadEmployee.message,
      EmployeeSnackbars.failureQrDownloadEmployee.closeBtn,
      EmployeeSnackbars.failureQrDownloadEmployee.config
    );
  }

  public failureQrDownloadPermission(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrDownloadPermission.message,
      EmployeeSnackbars.failureQrDownloadPermission.closeBtn,
      EmployeeSnackbars.failureQrDownloadPermission.config
    );
  }

  public failureQrCompanyInactive(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrCompanyInactive.message,
      EmployeeSnackbars.failureQrCompanyInactive.closeBtn,
      EmployeeSnackbars.failureQrCompanyInactive.config
    );
  }

  public successQrReset(): void {
    this.snackbar.open(
      EmployeeSnackbars.successQrReset.message,
      EmployeeSnackbars.successQrReset.closeBtn,
      EmployeeSnackbars.successQrReset.config
    );
  }

  public failureQrReset(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrReset.message,
      EmployeeSnackbars.failureQrReset.closeBtn,
      EmployeeSnackbars.failureQrReset.config
    );
  }

  public failureQrResetEmployee(): void {
    this.snackbar.open(
      EmployeeSnackbars.failureQrResetEmployee.message,
      EmployeeSnackbars.failureQrResetEmployee.closeBtn,
      EmployeeSnackbars.failureQrResetEmployee.config
    );
  }
}
